import Home from './Home'
import New from './New'
import Edit from './Edit'

export default {
    Home,
    New,
    Edit
}